import { Field, type FieldProps, ErrorMessage } from "formik";
import { PropsWithChildren } from "react";

import styles from "./select.module.css";

interface ComponentProps extends PropsWithChildren {
  label: string;
  name: string;
  placeholder?: string;
  bg?: string;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>
  disabled?: boolean

}

const CustomSelect: React.FC<ComponentProps> = (props) => {
  const { name, label, placeholder, bg, children, onChange , disabled} = props;

  return (
    <Field name={name}>
      {({ field, form: { touched, errors }, meta }: FieldProps) => (
        <div className={styles.container}>
          <label key={label}>{label}</label>

          <select
            {...field}
            className={styles.select}
            // onChange={onChange}
            value={field.value} 
            onChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            disabled={disabled}
          >
            <option value=""  defaultValue={""}>
              {placeholder}
            </option>
            {children}
          </select>

          {meta.touched && meta.error && (
            <div className={styles.error}>{meta.error}</div>
          )}
          {/* <ErrorMessage name={name} /> */}
        </div>
      )}
    </Field>
  );
};

export default CustomSelect;
